import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {calendarDate} from 'shared/tools';

class NmbrTaxDocument extends DomainObject {
  id;
  documentType;
  taxYear;
  stage;
  createdAt;

  _relations = {
    _dates: ['createdAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      documentType: observable,
      taxYear: observable,
      stage: observable,
      createdAt: observable,
      name: computed,
      createdAtView: computed
    });

    this.merge(other);
  }

  get name() {
    return this.documentType.toUpperCase();
  }

  get createdAtView() {
    return calendarDate(this.createdAt);
  }
}

export default NmbrTaxDocument;
